import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css'

import { default as routes } from 'src/routes/Routes';

const App = () => {
  const { t, i18n } = useTranslation("common");

  useEffect(() => {
    document.title = t('title');
  }, [i18n.language, t]);

  return (

    <Router>
      <Routes>
        {routes.map((route, index) => (
          <Route key={`layout__${index}`} path={route.path} element={<route.element />}>
            {route.routes.map((nestedRoute, nestedIndex) => (
              <Route
                key={`route__${nestedIndex}`}
                path={nestedRoute.path}
                element={<nestedRoute.element />}
              />
            ))}
          </Route>
        ))}
      </Routes>
    </Router>

  );
}


export default App;
